import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/transitional/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { useSearchParams } from '../../../utils/searchParams';
import { useClearFilter, useToggleFilter, useSetFilter } from '../publicCatalogFiltersHooks';
import { jsx as _jsx } from "react/jsx-runtime";
const PublicCatalogMobileFilterOption = ({
  filterName,
  option,
  isLast
}) => {
  const [searchParams] = useSearchParams();
  const clearFilter = useClearFilter();
  const toggleFilter = useToggleFilter();
  const setFilter = useSetFilter();
  const currentlySelectedFilterOptions = searchParams[filterName] || [];
  // language may not have multiple values so only take the last one
  const validSelectedOptions = filterName === 'language' ? currentlySelectedFilterOptions.slice(-1) : currentlySelectedFilterOptions;
  const isOptionSelected = option === 'ALL' && validSelectedOptions.length === 0 || validSelectedOptions.includes(option);
  const handleOptionClick = () => {
    if (option === 'ALL') {
      clearFilter(filterName);
      return;
    }
    if (filterName === 'language') {
      setFilter(filterName, option);
      return;
    }
    toggleFilter(filterName, option);
  };
  return /*#__PURE__*/_jsx(View, {
    borderBlockEndColor: "border-core-subtle",
    borderBlockEndStyle: isLast ? 'none' : 'solid',
    borderBlockEndWidth: "100",
    children: /*#__PURE__*/_jsx(Button, {
      marginInlineStart: "0",
      onClick: handleOptionClick,
      paddingBlock: "200",
      paddingInlineEnd: "500",
      use: "unstyled",
      children: /*#__PURE__*/_jsx(View, {
        inlineSize: "100%",
        children: /*#__PURE__*/_jsx(Checkbox, {
          checked: isOptionSelected,
          onClick: event => {
            event.preventDefault();
          },
          tabIndex: -1,
          children: filterName === 'language' ? LanguageNames[option] : /*#__PURE__*/_jsx(FormattedMessage, {
            message: `academyPublic.catalogPage.filters.${filterName}.options.${option}`
          })
        })
      })
    }, option)
  });
};
export default PublicCatalogMobileFilterOption;